// src/pages/pedidos/PainelPedido.js
import { useState, useEffect, useRef, useCallback } from 'react';
import './PainelPedido.css';
import { fetchData } from '../../services/Api';
import { formatDateInput, formatTime } from '../../utils/dateTimeUtils';
import { useNavigate } from "react-router-dom";
import { MdTableRestaurant } from "react-icons/md"; // ícone opcional


import PageContainer from '../../components/geral/PageContainer';
import PageHeader from '../../components/geral/PageHeader';
import PageContent from '../../components/geral/PageContent';
import StatusCard from './StatusCard';
import ModalContainer from '../../components/modalForm/ModalContainer';
import ModalBody from '../../components/modalForm/ModalBody';
import Input from '../../components/input/Input';
import ModalFooter from '../../components/modalForm/ModalFooter';
import ModalHeader from '../../components/modalForm/ModalHeader';
import { Pedido } from '../../models/pedidos/Pedido';
import { getOrigemPedidoString } from '../../models/pedidos/OrigemPedidoEnum';
import CadPedido from './CadPedido';
import { usePedido } from '../../contexts/pedidos/PedidoContext';
import { formatCurrency } from '../../utils/numberUtils';
import { useToken } from '../../contexts/geral/TokenContext';
import { MdFormatListBulletedAdd, MdLocalPrintshop } from 'react-icons/md';
import { usePrinter } from '../../contexts/geral/PrinterContext';
import { FaCalendarAlt, FaFileInvoice } from 'react-icons/fa';
import { VscRequestChanges } from 'react-icons/vsc';
import { FaArrowRightFromBracket } from 'react-icons/fa6';
import { FaClock } from 'react-icons/fa';
import { FiClipboard, FiMapPin, FiPhone } from 'react-icons/fi';
import { useAlert } from '../../contexts/geral/AlertContext';
import { useChatBotWhatsapp } from '../../contexts/pedidos/ChatBotWhatsappContext';
import Select from '../../components/input/Select';
import { Caixa } from '../../models/caixas/Caixa.js';
import { useMessage } from '../../contexts/geral/MessageContext.js';
import { useConfigModulo } from '../../contexts/administrativo/ConfigModuloContext.js';
import ModalFinalizarVenda from '../vendas/ModalFinalizarVenda.js';
import { Nota } from '../../models/vendas/Nota.js';
import { montarNotaPedidoPDV } from '../../services/vendas/PDVService.js';
import { useStoreStatus } from '../../contexts/pedidos/StoreStatusContext.js';
import { useCliente } from '../../contexts/pessoas/ClienteContext';
import ModalHorarios from './ModalHorarios';
import ModalTempoPreparo from './ModalTempoPreparo.js';
import ModalLocalizacaoPedido from './ModalLocalizacaoPedido';
import { useConfigPedido } from '../../contexts/pedidos/ConfigPedidoContext.js';
import { useSSE } from '../../contexts/geral/SSEContext.js';
import {
  alterarStatusPedido,
  atualizarPixPago,
  getDashPedido,
} from '../../services/pedidos/PedidoService.js';
import { getNumeroPedido } from '../../utils/pedidoUtils';
import { StatusPedido, getStatusPedidoDescricao } from '../../models/pedidos/StatusPedido';

const subtrairHoras = (data, horas) => {
  const novaData = new Date(data);
  novaData.setHours(novaData.getHours() - horas);
  return novaData;
};

const PainelPedido = () => {
  const navigate = useNavigate();

  const [pedidos, setPedidos] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isModalCadOpen, setIsModalCadOpen] = useState(false);  
  const [isFiltroModalOpen, setIsFiltroModalOpen] = useState(false);
  const [dataInicio, setDataInicio] = useState(() => {                
    return formatDateInput(new Date()); // "YYYY-MM-DD"
  });
  
  const [dataFim, setDataFim] = useState(() => {    
    const amanha = new Date();
    amanha.setDate(amanha.getDate() + 1);
    return formatDateInput(amanha);
  });

  const [disabledButtons, setDisabledButtons] = useState({});
  const [pixPagoAtualizando, setPixPagoAtualizando] = useState({});
  // Pedido com a localização (link do Google Maps) aberta na modal "Ver localização"
  const [pedidoLocalizacao, setPedidoLocalizacao] = useState(null);
  //const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));  

  const { setPedidoSel, getPedidoById, existeNotaPorPedido, refreshPedidoAlerta } = usePedido();
  const { getOrCreateClienteByTelefone } = useCliente();
  const { printPedidoPDFById } = usePrinter();
  const { showAlert } = useAlert(); // Acessa showAlert do AlertContext
  const { showMessage } = useMessage();
  const { configPedido, updateConfigPedido } = useConfigPedido();

  const [isModalStatusOpen, setIsModalStatusOpen] = useState(false);
  const [isModalTempoPreparoOpen, setIsModalTempoPreparoOpen] = useState(false);
  const [isModalTempoPreparoAceiteOpen, setIsModalTempoPreparoAceiteOpen] = useState(false);
  const [previsaoMin, setPrevisaoMin] = useState('');
  const [pedidoAceitePendenteId, setPedidoAceitePendenteId] = useState(null);
  const [isConfirmandoTempoPreparoAceite, setIsConfirmandoTempoPreparoAceite] = useState(false);
  const { chatBotWhatsapp, setChatBotWhatsapp, updateChatBotWhatsapp } = useChatBotWhatsapp();
  const {storeStatus, setStoreStatus, fetchStatus} = useStoreStatus();
  const storeStatusInicialRef = useRef(null);  
  const [isModalHorariosOpen, setIsModalHorariosOpen] = useState(false);
  const [obsAgendouPedido, setObsAgendouPedido] = useState();
  const isSincronizandoPainelRef = useRef(false);

  useEffect(() => {
    setPrevisaoMin(configPedido?.previsaoMin ?? '');
  }, [configPedido]);

  // Atualiza o status da loja imediatamente ao abrir o painel.
  // As próximas atualizações são feitas junto com o polling de pedidos.
  useEffect(() => {
    fetchStatus();
  }, [fetchStatus]);


  // //Caixa
  const [caixaSel, setCaixaSel] = useState(new Caixa());  
  //Modulos
  const {configModuloSel} = useConfigModulo();

  //dados para nota
  const [showFinalizarVenda, setShowFinalizarVenda] = useState(false);
  const [nota, setNota] = useState(new Nota());
  const pedidoEmitindoIdRef = useRef(null);

  const handleCancelVenda = () => {
      setNota(new Nota());
      pedidoEmitindoIdRef.current = null;
      setShowFinalizarVenda(false);
  };

  const handleConfirmVenda = async (_nota, options = {}) => {
      const { notaEmitida = false } = options;

      try {
        if (notaEmitida && pedidoEmitindoIdRef.current) {
          const pedidoSel = await getPedidoById(pedidoEmitindoIdRef.current);

          if (pedidoSel?.statusPedido === StatusPedido.AguardandoRetiradaEntrega) {
            await alterarStatusPedido({
              pedidoId: pedidoSel.id,
              statusPedido: StatusPedido.Concluido,
            });
          }
        }
      } catch (error) {
        console.error("Erro ao concluir pedido após emissão da nota:", error);
        showAlert(error?.message || error, 'danger');
      } finally {
        setNota(new Nota());
        pedidoEmitindoIdRef.current = null;
        setShowFinalizarVenda(false);
        fetchPedidos();
      }
  };

  useEffect(() => {
    const fetchCaixa = async () => {
      try {
        const result = await fetchData('/Caixa', { caixaId: 1 });
        setCaixaSel(result);
      } catch (error) {
        console.error("Erro ao buscar o status do caixa:", error);
        showAlert('Erro ao buscar o status do caixa', 'danger');
      }
    };

    fetchCaixa();
  }, []);


  const salvarStatus = async () => {
    try {
 
      updateChatBotWhatsapp(chatBotWhatsapp);      
      
      setIsModalStatusOpen(false);
    } catch (error) {
      showAlert('Erro ao salvar status', 'danger');
    }
  };

  const handleCancelarStatus = () => {
    if (storeStatusInicialRef.current !== null) {
      setStoreStatus({
        ...storeStatus,
        aberto: storeStatusInicialRef.current
      });

      // também mantém o ChatBot sincronizado
      setChatBotWhatsapp({
        ...chatBotWhatsapp,
        fechado: !storeStatusInicialRef.current
      });
    }

    storeStatusInicialRef.current = null;
    setIsModalStatusOpen(false);
  };

  //sincronismo
  // const [messages, setMessages] = useState([]);
  const {token} = useToken();
  const { subscribeToEvent } = useSSE();

   // Função para determinar o texto do botão com base no status do pedido
   const getButtonLabel = (status) => {
    switch (status) {
      case "Em análise":
        return "Aceitar";
      case "Em Produção":
        return "Pronto";
      case "Aguardando Retirada/Entrega":
        return "Concluir";
      default:
        return "Fechar";
    }
  };

  const resetTempoPreparoAceiteModal = () => {
    setPedidoAceitePendenteId(null);
    setIsModalTempoPreparoAceiteOpen(false);
  };

  const handleOpenTempoPreparoAceiteModal = (pedidoId) => {
    setPedidoAceitePendenteId(pedidoId);
    setIsModalTempoPreparoAceiteOpen(true);
  };

  const handleCancelarTempoPreparoAceite = () => {
    if (isConfirmandoTempoPreparoAceite) {
      return;
    }

    resetTempoPreparoAceiteModal();
  };


  const validarCaixaAbertoParaFaturamento = () => {
    if (!caixaSel?.aberto) {
      showMessage(
        "Caixa fechado! Para concluir o pedido é necessário abrir o caixa.",
        'warning'
      );
      return false;
    }

    return true;
  };

  const handleEmitirDFeComValidacao = async (pedidoId, pedido = null) => {
    if (!validarCaixaAbertoParaFaturamento()) {
      return;
    }

    const pedidoSel = pedido ?? await getPedidoById(pedidoId);

    if (pedidoSel?.comandaId) {
      showMessage(
        "O pedido pertence a uma mesa. Emitir a nota no fechamento de mesas/comandas.",
        'warning'
      );
      return;
    }

    await handleEmitirDFe(pedidoId);
  };

  const handleImprimirPedidoAceito = async (pedidoId) => {
    if (!configModuloSel?.printPedidoAceito) {
      return;
    }

    const pedidoAtualizado = await getPedidoById(pedidoId);

    if (pedidoAtualizado?.id) {
      await printPedidoPDFById(pedidoAtualizado?.id);
    }
  };

  const handleAlteraStatus = async (pedidoId, options = {}) => {
    let {
      ignorarModalTempoPreparoAceite = false,
      tempoPreparoMinutos = configPedido?.previsaoMin,
    } = options;
    setDisabledButtons(prev => ({ ...prev, [pedidoId]: true }));

    try {
      const pedidoSel = await getPedidoById(pedidoId);

      if (pedidoSel.statusPedido !== StatusPedido.Cancelado) {

        // 🔹 se estiver ACEITANDO o pedido (Em análise → Em Produção)
        const vaiAceitarPedido =
          pedidoSel.statusPedido === StatusPedido.EmAnalise;

        if (
          vaiAceitarPedido &&
          configPedido?.tempoPreparoAceite &&
          !ignorarModalTempoPreparoAceite
        ) {
          setObsAgendouPedido(pedidoSel.observacao);
          handleOpenTempoPreparoAceiteModal(pedidoId);
          return false;
        }

        if (
          pedidoSel.statusPedido === StatusPedido.AguardandoRetiradaEntrega &&
          !caixaSel?.aberto
        ) {
          showMessage(
            "Caixa fechado! Para concluir o pedido é necessário abrir o caixa.",
            'warning'
          );
          return false;
        }

        const payload = {
          pedidoId: pedidoSel.id,
          statusPedido: pedidoSel.statusPedido + 1,
          tempoPreparoMinutos: vaiAceitarPedido ? tempoPreparoMinutos : null, //Só manda o tempo ao aceitar o pedido
        };

        await alterarStatusPedido(payload);
        refreshPedidoAlerta();
        //showAlert(response.message);

        // 🖨️ IMPRIME AUTOMATICAMENTE AO ACEITAR
        if (vaiAceitarPedido) {
          await handleImprimirPedidoAceito(pedidoSel.id);
        }

        return true;
      }

      return false;
    } catch (error) {
      console.error("Erro ao alterar status do pedido:", error);
      const mensagemEndpoint = error?.data?.message || error?.message;
      showMessage(
        typeof mensagemEndpoint === 'string' && mensagemEndpoint.trim()
          ? mensagemEndpoint
          : 'Não foi possível alterar o status do pedido.',
        'danger'
      );
      return false;
    } finally {
      setDisabledButtons(prev => ({ ...prev, [pedidoId]: false }));
    }
  };

  const handleConfirmarTempoPreparoAceite = async (tempoSelecionado) => {

    if (!pedidoAceitePendenteId) {
      resetTempoPreparoAceiteModal();
      return;
    }


    setIsConfirmandoTempoPreparoAceite(true);

    try {
      const alterouStatus = await handleAlteraStatus(pedidoAceitePendenteId, {
        ignorarModalTempoPreparoAceite: true,
        tempoPreparoMinutos: tempoSelecionado,
      });

      if (alterouStatus) {
        resetTempoPreparoAceiteModal();
      }
    } finally {
      setIsConfirmandoTempoPreparoAceite(false);
    }
  };

  const handleAtualizarPixPago = async (pedido) => {
    const novoStatus = !pedido.pixPago;
    setPixPagoAtualizando(prev => ({ ...prev, [pedido.id]: true }));

    try {
      await atualizarPixPago({ pedidoId: pedido.id, pixPago: novoStatus });
      setPedidos(prev => prev.map(grupo => ({
        ...grupo,
        pedidos: grupo.pedidos?.map(item => item.id === pedido.id
          ? { ...item, pixPago: novoStatus }
          : item),
      })));
    } catch (error) {
      console.error('Erro ao atualizar o pagamento PIX:', error);
      showMessage(error?.message || 'Não foi possível atualizar o pagamento PIX.', 'danger');
    } finally {
      setPixPagoAtualizando(prev => ({ ...prev, [pedido.id]: false }));
    }
  };

  const fetchPedidos = useCallback(async () => {
    const tempoPedidoHoras = configPedido?.tempoPedido !== null && configPedido?.tempoPedido !== undefined && configPedido?.tempoPedido !== ''
      ? Number(configPedido.tempoPedido)
      : 12;
    const hoje = formatDateInput(new Date());
    const dataBaseInicio = dataInicio === hoje
      ? new Date()
      : new Date(dataInicio + "T00:00:00");
    const inicio = subtrairHoras(dataBaseInicio, tempoPedidoHoras);
    const fim = new Date(dataFim + "T23:59:59");

    try {
      const pedidosData = await getDashPedido({
        dataHoraI: inicio,
        dataHoraF: fim,
      });


      setPedidos(pedidosData);
      // Limpa o erro anterior para a tela se recuperar após a conexão voltar.
      setError(null);
      setIsLoading(false);
      return pedidosData;
    } catch (error) {
      setError(error);
      setIsLoading(false);
      return null;
    }
  }, [configPedido?.tempoPedido, dataInicio, dataFim]);

  useEffect(() => {
    if (!token || token === 'null') {
      return undefined;
    }

    return subscribeToEvent('pedido', (event) => {
      try {
        const data = JSON.parse(event.data);
        const { pedidoId } = data;

        if (!pedidoId) return;

        fetchPedidos();
      } catch (err) {
        console.error('Erro ao processar SSE de pedido no painel:', err, event.data);
      }
    });
  }, [token, subscribeToEvent, fetchPedidos]);

  useEffect(() => {
    fetchPedidos();
  }, [fetchPedidos]);

  useEffect(() => {
    if (!token || token === 'null') {
      return undefined;
    }

    // Sincronização de segurança para recuperar pedidos que possam ter sido perdidos pelo SSE.
    const sincronizarPedidos = async () => {
      // Evita duas sincronizações ao mesmo tempo ao retornar do modo de espera.
      if (isSincronizandoPainelRef.current) {
        return;
      }

      isSincronizandoPainelRef.current = true;

      try {
        const pedidosData = await fetchPedidos();

        if (pedidosData) {
          // Reaproveita a resposta do painel para atualizar o alerta sem repetir o GetDashPedido.
          await refreshPedidoAlerta(pedidosData);
        }

        await fetchStatus();
      } finally {
        isSincronizandoPainelRef.current = false;
      }
    };

    // Atualiza imediatamente quando o navegador identifica que a internet voltou.
    const handleOnline = () => {
      sincronizarPedidos();
    };

    // Ao retornar para a aba ou do modo de espera, busca os pedidos sem aguardar o próximo intervalo.
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && navigator.onLine) {
        sincronizarPedidos();
      }
    };

    // Mantém uma conferência periódica caso algum evento do SSE não seja recebido.
    const interval = setInterval(sincronizarPedidos, 5 * 60 * 1000);
    window.addEventListener('online', handleOnline);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearInterval(interval);
      window.removeEventListener('online', handleOnline);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [token, fetchPedidos, refreshPedidoAlerta, fetchStatus]);


  const handleImprimirPedido = async (pedidoId) => {
    try {
      if (pedidoId !== 0) {
        await printPedidoPDFById(pedidoId);
      }
    } catch (error) {
      console.error('Erro ao buscar detalhes do pedido:', error);
    }
  };

  const handleEmitirDFe = async (pedidoId) => {
    try {
      if (pedidoId !== 0) {

        //Verifica se já não existe nota para o pedido
        const jaExisteNota = await existeNotaPorPedido(pedidoId);

        if (jaExisteNota) {
          showMessage('Já existe nota emitida para este pedido.', 'warning');
          return;
        }

        const pedido = await getPedidoById(pedidoId);

        // Busca cliente por telefone e cadastra automaticamente quando não existir.
        const clienteByTelefone = await getOrCreateClienteByTelefone({
          telefone: pedido.telefoneCliente || pedido.cliente?.telefone || '',
          nome: pedido.nomeCliente || pedido.cliente?.nome || '',
          enderecoCliente: pedido.enderecoCliente || '',
        });

        // A conversão fiscal valida os totais do pedido, incorpora o cashback em
        // vDesc e inicia qualquer forma de pagamento com troco zerado.
        const notaPayload = montarNotaPedidoPDV({
          pedido,
          clienteId: clienteByTelefone?.id || pedido.clienteAppId || 1
        });

        // Atualizar o estado
        setNota(notaPayload);
        pedidoEmitindoIdRef.current = pedidoId;
        setShowFinalizarVenda(true);
      }
    } catch (error) {
      console.error("Erro ao buscar detalhes do pedido:", error);
      showMessage(error?.message || 'Não foi possível preparar o pedido para emissão da nota.', 'danger');
    }
  };


  const handleCadNovoPedido = async () => {
    try {

      setPedidoSel(new Pedido());      
      setIsModalCadOpen(true);
      
    } catch (error) {
      console.error('Erro ao buscar detalhes do pedido:', error);
    }
  };

  const handleDetalhePedido = async (pedidoId) => {
    try {
      const pedido = await getPedidoById(pedidoId);
      setPedidoSel(pedido);          // joga no contexto
      setIsModalCadOpen(true);       // abre o CadPedido direto
    } catch (error) {
      console.error('Erro ao buscar detalhes do pedido:', error);
    }
  };

  const handleCloseCadPedido = () => {
    setIsModalCadOpen(false);
    setPedidoSel(new Pedido()); // opcional: limpa seleção
  };

  const openFiltroModal = () => {
    setIsFiltroModalOpen(true);
  };

  const closeFiltroModal = () => {    
    setIsFiltroModalOpen(false);  
    fetchPedidos();  
  };

  const disableButtonTemporarily = (pedidoId, callback) => {
    setDisabledButtons(prev => ({ ...prev, [pedidoId]: true }));

    Promise.resolve(callback()) // garante que aceita funções sync e async
      .catch(err => console.error(err))
      .finally(() => {
        setDisabledButtons(prev => ({ ...prev, [pedidoId]: false }));
      });
  };

  const handleOpenTempoPreparoModal = () => {
    setPrevisaoMin(configPedido?.previsaoMin ?? '');
    setIsModalTempoPreparoOpen(true);
  };

  const handleCancelarTempoPreparo = () => {
    setPrevisaoMin(configPedido?.previsaoMin ?? '');
    setIsModalTempoPreparoOpen(false);
  };

  const handleSalvarTempoPreparo = async () => {
    const tempo = Number(previsaoMin);

    // if (!tempo || tempo <= 0) {
    //   showMessage('Informe um tempo de preparo valido.');
    //   return;
    // }

    await updateConfigPedido({
      ...configPedido,
      previsaoMin: tempo,
    });

    setIsModalTempoPreparoOpen(false);
  };



  if (isLoading) {
    return <div className="painel-pedido-feedback" role="status"><span className="spinner-border spinner-border-sm" aria-hidden="true" /> Carregando pedidos...</div>;
  }

  if (error) {
    return <div className="painel-pedido-feedback painel-pedido-erro" role="alert">Erro ao carregar os dados: {error.message}</div>;
  }

  const caixaData = [
    { status: 'Em análise', bgColor: 'bg-danger', icon: 'ion ion-pie-graph' },
    { status: 'Em Produção', bgColor: 'bg-warning', icon: 'ion ion-person-add' },
    { status: 'Aguardando Retirada/Entrega', bgColor: 'bg-info', icon: 'ion ion-bag' },
    // 🔹 só inclui "Concluído" se o módulo permitir
  ...(configModuloSel?.exibirConcluido
    ? [{ status: 'Concluído', bgColor: 'bg-success', icon: 'ion ion-stats-bars' }]
    : []),
    
  ];

  const statusColors = {
    'Em análise': 'red',
    'Em Produção': 'yellow',
    'Aguardando Retirada/Entrega': 'blue',
    'Concluído': 'green',
  };

  return (
  <>
    <div className="painel-pedido-page">
    <PageContainer>
      <PageHeader>
        <div className="header-row">
          <div className="painel-pedido-heading">
            <h2 className="page-title"><FiClipboard aria-hidden="true" /> Gestão de Pedidos</h2>
            {/* <span className="painel-pedido-periodo">{dataInicio.split('-').reverse().join('/')} a {dataFim.split('-').reverse().join('/')}</span> */}
          </div>

          <div className="group-div">
            {configModuloSel?.controleMesa && (
            <button
              type="button"
              className="btn btn-secondary btn-responsive"
              onClick={() => navigate("/mesaPage")}
            >
              Mesas <MdTableRestaurant />
            </button>)}

            <button
              type="button"
              className="btn btn-secondary btn-responsive btn-tempo-preparo"
              onClick={handleOpenTempoPreparoModal}
            >
              <FaClock style={{ marginRight: '6px' }} />
              Preparo: {configPedido?.previsaoMin ?? 0} min
            </button>            

            <button
              type="button"
              className="btn btn-primary"
              onClick={openFiltroModal}
            >
              Filtrar Datas <FaCalendarAlt />
            </button>

            <button
              type="button"
              className="btn btn-success painel-pedido-novo"
              onClick={() => handleCadNovoPedido()}
            >
              Incluir Pedido <MdFormatListBulletedAdd />
            </button>

            <button
              className={`status-toggle-btn ${storeStatus?.aberto ? 'open' : 'closed'}`}
              type="button"
              aria-label={`Estabelecimento ${storeStatus?.aberto ? 'aberto' : 'fechado'}. Alterar status`}
              onClick={() => {
                storeStatusInicialRef.current = storeStatus?.aberto;
                setIsModalStatusOpen(true);
              }}
            >
              <span className="status-loja-indicador" aria-hidden="true" />
              {storeStatus?.aberto ? 'Aberto' : 'Fechado'}
            </button>
          </div>
        </div>
      </PageHeader>


      <PageContent maxAltura="100vh">
        <div className="flex-container">
          
          {caixaData.map((caixa, index) => {
            const pedidoStatus = pedidos?.find(
              (p) => p.statusPedido === caixa.status
            );
            //Formata os pedidos para exibir as informações necessárias no card
            const pedidosList = pedidoStatus?.pedidos.map((p) => ({
              ...p,
              hora: formatTime(p.dataHoraPedido),
              valorTotal: formatCurrency(p.valorTotal),
              entrega: p.tipoEntrega?.descricao,
              formaPag: p.formaPag?.descricao,
              ehPix: Number(p.formaPag?.meioPag) === 17,
              pixPago: p.pixPago === true,
              numeroPedido: getNumeroPedido(p, configModuloSel),
            })) || [];

            return (
              <div
                key={index}
                className={`pedido-coluna ${statusColors[caixa.status] || ''}`}
                role="region"
                aria-label={caixa.status}
              >
                <StatusCard
                  status={caixa?.status}
                  color={statusColors[caixa.status]}
                  count={pedidoStatus ? pedidoStatus.qtde : 0}
                />

                {pedidosList?.length > 0 && (
                  <div className="pedido-list">
                    {pedidosList.map((p) => (
                      <div className="pedido-item" key={p.id}>
                        <div className="pedido-item-heading">
                          <strong className="pedido-numero">Pedido #{p.numeroPedido}</strong>
                          <div className="pedido-hora"><FaClock aria-hidden="true" /> <span>{p.hora}</span></div>
                        </div>
                        <div className="pedido-columns">
                          <div className="pedido-left">
                            <p className="pedido-cliente">
                              <b>{p.nomeCliente}</b>
                            </p>
                            {p.telefoneCliente && (
                              <p className="pedido-telefone">
                                <FiPhone aria-hidden="true" /> <span>{p.telefoneCliente}</span>
                              </p>
                            )}                            
                            <p className="pedido-entrega">
                              <FiMapPin aria-hidden="true" /> <b>{p.entrega}</b>
                            </p>
                            {/* Só aparece quando o cliente enviou a localização pelo App */}
                            {Pedido.possuiLocalizacao(p) && (
                              <button
                                type="button"
                                className="pedido-localizacao-button"
                                onClick={() => setPedidoLocalizacao(p)}
                                aria-label={`Ver localização do pedido ${p.numeroPedido}`}
                              >
                                <FiMapPin aria-hidden="true" />
                                <span>Ver localização</span>
                              </button>
                            )}
                          </div>
                          <div className="pedido-right">
                            
                            {configModuloSel?.exibirOrigemPedido && (
                              <p>
                                Origem: <b>{getOrigemPedidoString(p.origemPedido)}</b>
                              </p>
                            )}
                            {typeof p.taxaEntrega === 'number' && p.taxaEntrega > 0 && (
                              <p>
                                Taxa Entrega: <b>{formatCurrency(p.taxaEntrega)}</b>
                              </p>
                            )}

                            {/* {typeof p.valorDesconto === 'number' && p.valorDesconto > 0 && (
                              <p>
                                Desconto: <b>{formatCurrency(p.valorDesconto)}</b>
                              </p>
                            )} */}
                            
                            <p className="pedido-valor">
                              <span>Total</span> <b>{p.valorTotal}</b>
                            </p>
                            {p.formaPag && (
                            <div className="pedido-pagamento">
                              <span>Pagamento: <b>{p.formaPag}</b></span>
                              {p.ehPix && (
                                <button
                                  type="button"
                                  role="switch"
                                  aria-checked={p.pixPago}
                                  aria-label={`Marcar PIX do pedido ${p.numeroPedido} como ${p.pixPago ? 'não pago' : 'pago'}`}
                                  className={`pix-pago-switch ${p.pixPago ? 'pago' : 'pendente'}`}
                                  disabled={pixPagoAtualizando[p.id]}
                                  onClick={() => handleAtualizarPixPago(p)}
                                  title={p.pixPago ? 'PIX pago' : 'PIX não pago'}
                                >
                                  <span className="pix-pago-switch-indicador" />
                                  <span>{p.pixPago ? 'Pago' : 'Pendente'}</span>
                                </button>
                              )}
                            </div>)}
                            {typeof p.trocoPara === 'number' && p.trocoPara > 0 && (
                              <p>
                                Troco para: <b>{formatCurrency(p.trocoPara)}</b>
                              </p>
                            )}
                            {/* <button onClick={() => handleDetalhePedido(p.id)}>
                              Gerenciar
                            </button> */}
                          </div>
                        </div>
                        {p.enderecoCliente && (
                          <div className="pedido-address">
                            <p>
                              Endereço: <b>{p.enderecoCliente}</b>
                            </p>
                            {p.distancia && (
                              <p>
                                Distância: <b>{p.distancia} km</b>
                              </p>
                            )}
                          </div>
                        )}
                        <div className="pedido-footer">
                          {p.statusPedido === StatusPedido.AguardandoRetiradaEntrega ? (
                            <button
                              type="button"
                              className="btn btn-primary"
                              disabled={disabledButtons[p.id]}
                              onClick={() => disableButtonTemporarily(p.id, () => handleEmitirDFeComValidacao(p.id, p))}
                            >
                              Emitir Nota <FaFileInvoice />
                            </button>
                          ) : (     
                              <>
                              {!configModuloSel?.printPedidoAceito && (
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  disabled={disabledButtons[p.id]}
                                  onClick={() => disableButtonTemporarily(p.id, () => handleImprimirPedido(p.id))}
                                >
                                  Imprimir <MdLocalPrintshop />
                                </button>
                              )}
                              </>                                                   
                            )
                          }

                          <button
                            type="button"
                            className="btn btn-secondary"
                            disabled={disabledButtons[p.id]}
                            onClick={() => disableButtonTemporarily(p.id, () => handleDetalhePedido(p.id))}
                          >
                            Gerenciar <VscRequestChanges />
                          </button>
                          {/* se tiver pronto nao mostra esse botao */}
                          {p.statusPedido !== StatusPedido.Concluido && (
                          <button
                            type="button"
                            className="btn btn-success"
                            disabled={disabledButtons[p.id]}
                            onClick={() => disableButtonTemporarily(p.id, () => handleAlteraStatus(p.id))}
                          >
                            {getButtonLabel(getStatusPedidoDescricao(p.statusPedido))} <FaArrowRightFromBracket />
                          </button>)}
                        </div>

                      </div>
                    ))}
                  </div>
                )}
                {pedidosList.length === 0 && (
                  <div className="pedido-coluna-vazia">
                    <FiClipboard aria-hidden="true" />
                    <span>Nenhum pedido nesta etapa</span>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Modal de Filtro de Datas */}
        <ModalContainer largura="400px" show={isFiltroModalOpen} variant="cadastro" onHide={closeFiltroModal} contentClassName="painel-pedido-filtro">
          <ModalHeader title="Filtrar por Data" onHide={closeFiltroModal} icon={FaCalendarAlt} />

          <ModalBody>
          <div className="input-group">
              <Input
                label="Data Início:"
                onChange={(e) => setDataInicio(e.target.value) }
                type="date"
                size={150}
                value={dataInicio}
              />
              <Input
                label="Data Fim:"
                onChange={(e) => setDataFim(e.target.value)}
                type="date"
                size={150}
                value={dataFim}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <button type="button" className="btn btn-outline-secondary" onClick={closeFiltroModal}>
              Fechar
            </button>
          </ModalFooter>
        </ModalContainer>
      </PageContent>
    </PageContainer>
    </div>

    <CadPedido
      isOpen={isModalCadOpen}
      //novoPedido={novoPedidoAux}
      onClose={handleCloseCadPedido}
    />

    <ModalContainer largura="450px" show={isModalStatusOpen}>
      <ModalHeader>
        <h2>Status do Estabelecimento</h2>
      </ModalHeader>
      <ModalBody>
        <div className="status-row">

          <Select 
            label="Status:"
            value={storeStatus?.aberto}
            size={170}
            onChange={(e) => {
              const isAberto = e.target.value === 'true';

              setChatBotWhatsapp({ 
                ...chatBotWhatsapp, 
                fechado: !isAberto
              });

              setStoreStatus({
                ...storeStatus,
                aberto: isAberto
              });
            }}
            options={[
              { value: false, label: 'Fechado' },
              { value: true, label: 'Aberto' }
            ]}                            
          />

          <button
            className="btn-horarios"
            onClick={() => setIsModalHorariosOpen(true)}
          >
            <FaClock style={{ marginRight: '6px' }} />
            Horários
          </button>

        </div>

        {storeStatus?.aberto === false && (
          <div className="form-group">
            <label className="form-label">Mensagem quando fechado:</label>
            <textarea
              value={chatBotWhatsapp?.msgFechado}
              onChange={(e) =>
                setChatBotWhatsapp({
                  ...chatBotWhatsapp,
                  msgFechado: e.target.value
                })
              }
              rows={4}
              className="form-control"
            />
          </div>
        )}
      </ModalBody>

      <ModalFooter>
        <button
          className="btn btn-secondary"
          onClick={handleCancelarStatus}
        >
          Cancelar
        </button>

        <button className="btn btn-primary" onClick={salvarStatus}>
          Salvar
        </button>
      </ModalFooter>
    </ModalContainer>

    <ModalContainer largura="400px" show={isModalTempoPreparoOpen}>
      <ModalHeader>
        <h2>Tempo de Preparo</h2>
      </ModalHeader>
      <ModalBody>
        <Input
          label="Tempo de Preparo (min)"
          value={previsaoMin}
          onChange={(e) => setPrevisaoMin(e.target.value)}
          type="number"
          size={180}
        />
      </ModalBody>
      <ModalFooter>
        <button
          className="btn btn-secondary"
          onClick={handleCancelarTempoPreparo}
        >
          Cancelar
        </button>
        <button
          className="btn btn-primary"
          onClick={handleSalvarTempoPreparo}
        >
          Salvar
        </button>
      </ModalFooter>
    </ModalContainer>

    <ModalTempoPreparo
      isOpen={isModalTempoPreparoAceiteOpen}
      previsaoMinPadrao={configPedido?.previsaoMin}
      isConfirmandoTempoPreparoAceite={isConfirmandoTempoPreparoAceite}
      onCancel={handleCancelarTempoPreparoAceite}
      onConfirm={handleConfirmarTempoPreparoAceite}
      showMessage={showMessage}
      obsPedido={obsAgendouPedido}
    />
    <ModalFinalizarVenda
        show={showFinalizarVenda}
        onHide={handleCancelVenda}
        nota={nota}
        setNota={setNota}
        onConfirm={handleConfirmVenda}
        permitirEditarItens={true}
    /> 

    <ModalLocalizacaoPedido
      pedido={pedidoLocalizacao}
      onClose={() => setPedidoLocalizacao(null)}
    />

    <ModalHorarios
      show={isModalHorariosOpen}
      onClose={async () => {
        await fetchStatus();
        setIsModalHorariosOpen(false);
        setIsModalStatusOpen(false);//fecha a modal pro usuário não salvar duas vezes
      }}
      horarios={[]} // depois você conecta na API
      onSave={(dados) => {
        console.log("Horários salvos:", dados);
      }}
    />
  </>
 
  );
};

export default PainelPedido;


